//react-components
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

// Components
import Dashboard from "./Dashboard";

//Action
import {
  getStatusCountAction,
  getTotalCountOfLoansForBarchartAction,
} from "./DashboardAction";

//Utils
import Utility from "../Utils/Utility";

// Constants
import {
  LOAN_APPLICATION_STATUS,
  LOAN_CATEGORY_LEGEND,
} from "../Utils/Constants";
import { APPLICATION_CONFIGURATIONS } from "../Utils/ApplicationConfigurations";

class DashboardContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      requestsPieData: [],
      requestsPieColors: [],
      barchartColors: [
        Utility.getColourValueForApplicationStatus(
          LOAN_APPLICATION_STATUS.approved
        ),
        Utility.getColourValueForApplicationStatus(
          LOAN_APPLICATION_STATUS.rejected
        ),
      ],
      barChartDataCountColors: ["#037E85"],
      barChartDataCountKeys: [],
      totalRequests: 0,
      barchartData: [],
      barChartDataCount: [],
    };
  }

  componentDidMount() {
    let currentMonthYearObject = Utility.getCurrentMonthYear();
    this.getStatusCountDetails(
      "",""
    );

    this.handleMonthYearChangeForBarChartCount(
      currentMonthYearObject.currentMonth,
      currentMonthYearObject.currentYear
    );
  }

  /**
   * This function will get called by child component on change of month year selection for status count data.
   */
  handleChangeMonthYearSelectionForRequests = (month, year) => {
    this.getStatusCountDetails(month, year);
  };

  handleMonthYearChangeForBarChartCount = (month, year) => {
    this.getTotalCountOfLoansForBarchartAction(month, year);
  };

  /**
   * This function will call status count action
   */
  getStatusCountDetails = (month, year) => {
    getStatusCountAction(month, year, (responseData) => {
      if (responseData?.data !== null) {
        let pieData = [];
        let pieColors = [];
        let totalRequests = 0;
        responseData?.data.map((statusInformation) => {
          pieData.push({
            category: statusInformation.category,
            value: statusInformation.count,
          });

          LOAN_CATEGORY_LEGEND.forEach((legend) => {
            if (legend.key === statusInformation.category) {
              pieColors.push(legend.color);
            }
          });

          totalRequests = totalRequests + statusInformation.count;
          return null;
        });
        this.setState({
          requestsPieData: pieData,
          requestsPieColors: pieColors,
          totalRequests: totalRequests,
        });
      }
    });
  };

  /**
   * This function will call branchwise count action
   */
  getTotalCountOfLoansForBarchartAction = (month, year) => {
    getTotalCountOfLoansForBarchartAction(month, year, (responseData) => {
      if (responseData !== null) {
        let barChartDataCount = [];
        let barChartDataCountKeys = ["Total"];
        responseData?.data.map((oneMonthCount) => {
          let year = oneMonthCount.year.toString().substring(2, 4);
          let name =
            Utility.getSpanishStringForMonth(
              Utility.getIntegerValue(oneMonthCount.month)
            ).substring(0, 3) +
            " " +
            year;
          let oneMonthCountForBranches = {};
          oneMonthCountForBranches["name"] = name;

          oneMonthCountForBranches[`Total`] = oneMonthCount.count;

          barChartDataCount.push(oneMonthCountForBranches);
          return null;
        });

        this.setState({
          barChartDataCount: barChartDataCount,
          barChartDataCountKeys: barChartDataCountKeys,
        });
      }
    });
  };

  render() {
    return (
      <Dashboard
        requestsPieChartData={this.state.requestsPieData}
        requestsPieColors={this.state.requestsPieColors}
        totalRequests={this.state.totalRequests}
        userRole={this.props.loginReducer.authority}
        handleChangeMonthYearSelectionForRequests={
          this.handleChangeMonthYearSelectionForRequests
        }
        handleMonthYearChangeForBarChartCount={
          this.handleMonthYearChangeForBarChartCount
        }
        barchartData={this.state.barchartData}
        barchartColors={this.state.barchartColors}
        barchartDataKeys={this.state.barchartDataKeys}
        barChartDataCount={this.state.barChartDataCount}
        barChartDataCountColors={this.state.barChartDataCountColors}
        barChartDataCountKeys={this.state.barChartDataCountKeys}
        LOAN_PORTFOLIO={this.props.LOAN_PORTFOLIO}
      />
    );
  }
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getStatusCountAction: getStatusCountAction,
      getTotalCountOfLoansForBarchartAction:
        getTotalCountOfLoansForBarchartAction,
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    loginReducer: state.loginReducer,
    dashboardReducer: state.dashBoardReducer,
  };
}

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(DashboardContainer);
